// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const FreebsdIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 64 64">
    <path d="M63.27 1.6c3.4 3.4-6.03 18.3-7.62 19.9s-5.6.12-9-3.27-4.86-7.4-3.27-9c1.6-1.63 16.5-11 19.89-7.62M15.7 5.2C10.52 2.28 3.15-.99.8 1.36c-2.38 2.38 1 9.92 3.98 15.11 2.64-4.65 6.4-8.5 10.92-11.27" />
    <path d="M58.08 20.32c.46 1.63.38 2.97-.38 3.73-1.8 1.8-6.7-.13-11.1-4.31-.29-.3-.62-.55-.91-.88a18 18 0 0 1-3.6-4.86c-1.55-2.76-1.93-5.2-.76-6.36.63-.63 1.64-.8 2.9-.59.8-.5 1.76-1.1 2.8-1.68a30.77 30.77 0 1 0 12.6 12.19 27 27 0 0 1-1.55 2.76z" />
  </svg>,
  "Freebsd",
);
export default FreebsdIcon;
